import React from "react";
import { Typography, Input, Button, Row, Col, Form } from "antd";
import LogoImg from "../../../assets/images/smallLogo.svg";
import BackArrowImg from "../../../assets/images/arrowLeft.png";
import BannerImg from "../../../assets/images/banner.png";
import { Link, useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { forgotPwd } from "../../../redux/action/auth/authAction";
import { toast } from "react-toastify";
const { Title, Text } = Typography;

const ForgotPassword = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSubmit = async (values) => {
    try {
      dispatch(
        forgotPwd(values, () => {
          navigate("/verify-otp");
        })
      );
    } catch (error) {
      toast.error("Failed. Please check your credentials.");
    }
  };

  return (
    <div className="signinContainer">
      <Row gutter={16} className="signin-row">
        <Col xs={24} sm={12}>
          <div className="leftSection cflex">
            <div className="leftContainer">
              <img
                src={LogoImg}
                alt="Logo"
                className="logo"
                height={200}
                width={200}
              />
              <div className="viewTenant">
                <div
                  className="backToLogin mt-3"
                  onClick={() => navigate(-1)}
                  style={{ cursor: "pointer" }}
                >
                  <img src={BackArrowImg} alt="BackArrowImg" />
                  Back To Login
                </div>
              </div>
              <Title level={2}>Forgot Password ?</Title>
              <Text className="subtitle mb-2">
                No worries, we’ll send you the reset instructions.
              </Text>
              <Form
                form={form}
                name="signin"
                layout="vertical"
                onFinish={handleSubmit}
                initialValues={{}}
                className="signin-form"
              >
                <Form.Item
                  label="Email"
                  name="email"
                  rules={[
                    { required: true, message: "Please enter your email!" },
                    { type: "email", message: "Enter a valid email!" },
                  ]}
                >
                  <Input size="large" placeholder="Email" />
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    className="customButton mt-3"
                    htmlType="submit"
                  >
                    Submit
                  </Button>
                  <Text className="subtitle mt-5 text-center">
                    © Cultiva 2025
                  </Text>
                </Form.Item>
              </Form>
            </div>
          </div>
        </Col>

        <Col xs={24} sm={12}>
          <div className="rightSection cflex">
            <img src={BannerImg} alt="Banner" className="banner" />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ForgotPassword;
